import { PropsWithChildren, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
// import ExtensionIcon from '@material-ui/icons/Extension';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
// import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
// import { MyGroupsSidebarItem } from '@backstage/plugin-org';
// import GroupIcon from '@material-ui/icons/People';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { LogoFullAcciona } from './LogoFullAcciona';
import { LogoIconAcciona } from './LogoIconAcciona';
// import UpdateIcon from '@material-ui/icons/Update';
import CategoryIcon from '@material-ui/icons/Category';
import AppsIcon from '@mui/icons-material/Apps';
import RequestIcon from '@mui/icons-material/CircleNotifications';
import WidgetsIcon from '@mui/icons-material/Widgets';
import ExternalUsersIcon from '@mui/icons-material/PeopleAlt';
// import { Administration } from '@backstage-community/plugin-rbac';
// import { Administration } from '@backstage-community/plugin-rbac';
import { applicationPageTranslationRef } from '../translation/application-page/application-page';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { projectPageTranslationRef } from '../translation/project-page/project-page';
import { requestPageTranslationRef } from '../translation/request-page/request-page';
import { LibraryBooks, Announcement } from '@material-ui/icons';
import { ImpersonationControl } from '../ImpersonationControl';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useApi, identityApiRef, configApiRef } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { announcementsTranslationRef } from '@internal/plugin-announcements/src/components/translation';
import { entityPageTranslationRef } from '../translation/entity-page/entity-page';
// import ChatIcon from '@material-ui/icons/Chat';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 5 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -1,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 10,
    display: 'flex',
    alignItems: 'center',
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFullAcciona /> : <LogoIconAcciona />}
      </Link>
    </div>
  );
};

const ExternalUsersSidebarItem = () => {

  const identityApi =
    useApi(identityApiRef);

  const catalogApi =
    useApi(catalogApiRef);

  const config =
    useApi(configApiRef);

  const [hasAccess, setHasAccess] =
    useState(false);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {

    let cancelled = false;

    const checkAccess = async () => {

      try {

        setLoading(true);

        const identity =
          await identityApi.getBackstageIdentity();

        const userEntityRef =
          identity.userEntityRef;

        const realUserName =
          userEntityRef.split('/')[1];

        let realUserEmail =
          realUserName;

        try {

          const userEntity =
            await catalogApi.getEntityByRef(
              userEntityRef,
            );

          const profile =
            userEntity?.spec?.profile as any;

          if (profile?.email) {
            realUserEmail =
              profile.email;
          }

        } catch (_) {
          // ignore
        }

        const backendUrl =
          config.getString('backend.baseUrl');

        const token =
          (await identityApi.getCredentials())
            .token;

        // =========================
        // PLATFORM ADMIN CHECK
        // =========================

        const adminResponse =
          await fetch(
            `${backendUrl}/api/openfga-client/check-permission`,
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json',
                Authorization:
                  `Bearer ${token}`,
              },
              body: JSON.stringify({
                user:
                  `user:${realUserEmail}`,
                action:
                  'platform_admin',
                resource:
                  'platform:main',
              }),
            },
          );

        if (!adminResponse.ok) {
          throw new Error(
            'Platform admin check failed',
          );
        }

        const adminData =
          await adminResponse.json();

        // =========================
        // JP PROJECT CHECK
        // =========================

        const jpResponse =
          await fetch(
            `${backendUrl}/api/openfga-client/list-user-entities`,
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json',
                Authorization:
                  `Bearer ${token}`,
              },
              body: JSON.stringify({
                user:
                  `user:${realUserEmail}`,
                type: 'project',
                relation: 'jp',
              }),
            },
          );

        if (!jpResponse.ok) {
          throw new Error(
            'JP check failed',
          );
        }

        const jpData =
          await jpResponse.json();

        // =========================
        // FINAL ACCESS
        // =========================

        const isPlatformAdmin =
          adminData.allowed || false;

        const isJP =
          jpData.objects &&
          jpData.objects.length > 0;

        if (!cancelled) {

          setHasAccess(
            isPlatformAdmin || isJP,
          );

          setLoading(false);
        }

      } catch (err) {

        console.error(err);

        if (!cancelled) {

          setHasAccess(false);

          setLoading(false);
        }
      }
    };

    checkAccess();

    return () => {
      cancelled = true;
    };

  }, [
    identityApi,
    catalogApi,
    config,
  ]);

  if (loading || !hasAccess) {
    return null;
  }

  return (
    <SidebarItem
      icon={ExternalUsersIcon}
      to="external-onboarding"
      text="External Users"
    />
  );
};

// Sidebar item único para administración
const AdminSidebarItem = () => {
  const identityApi = useApi(identityApiRef);
  const catalogApi = useApi(catalogApiRef);
  const config = useApi(configApiRef);
  const [isPlatformAdmin, setIsPlatformAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const checkPlatformAdmin = async () => {
      try {
        setLoading(true);
        const identity = await identityApi.getBackstageIdentity();
        const userEntityRef = identity.userEntityRef;
        const realUserName = userEntityRef.split('/')[1];
        let realUserEmail = realUserName;
        try {
          const userEntity = await catalogApi.getEntityByRef(userEntityRef);
          const profile = userEntity?.spec?.profile as any;
          if (profile?.email) realUserEmail = profile.email;
        } catch (_) {
          // ignore
        }
        const backendUrl = config.getString('backend.baseUrl');
        const token = (await identityApi.getCredentials()).token;
        const response = await fetch(`${backendUrl}/api/openfga-client/check-permission`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({
            user: `user:${realUserEmail}`,
            action: 'platform_admin',
            resource: 'platform:main',
          }),
        });
        if (!response.ok) {
          throw new Error(`Failed to check permission: ${response.statusText}`);
        }
        const data = await response.json();
        if (!cancelled) {
          setIsPlatformAdmin(data.allowed || false);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          setIsPlatformAdmin(false);
          setLoading(false);
        }
      }
    };
    checkPlatformAdmin();
    return () => {
      cancelled = true;
    };
  }, [identityApi, catalogApi, config]);

  if (loading || !isPlatformAdmin) return null;

  return <SidebarItem icon={AdminPanelSettingsIcon} to="admin" text="Administración" />;
};

export const Root = ({ children }: PropsWithChildren<{}>) => {
  const translationApplicationPage = useTranslationRef(applicationPageTranslationRef);
  const translationProjectPage = useTranslationRef(projectPageTranslationRef);
  const translationRequestPage = useTranslationRef(requestPageTranslationRef);
  const translationAnnouncements = useTranslationRef(announcementsTranslationRef);
  const translationEntityPage = useTranslationRef(entityPageTranslationRef);
  return (
    <SidebarPage>
      <Sidebar>
        <SidebarLogo />
        <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
          <SidebarItem icon={SearchIcon} to="search" text={translationEntityPage.t('root.search')} />
        </SidebarGroup>
        <SidebarGroup label="Menu" icon={<MenuIcon />}>
          {/* Global nav, not org-specific */}
          <SidebarItem icon={HomeIcon} to="home" text={translationEntityPage.t('homePage.home')} />
          <SidebarItem icon={CategoryIcon} to="catalog" text={translationEntityPage.t('root.catalog')} />
          <SidebarItem icon={AppsIcon} to="applications" text={translationApplicationPage.t('applicationPage.title')} />
          <SidebarItem icon={WidgetsIcon} to="projects" text={translationProjectPage.t('projectPage.title')} />
          <SidebarItem icon={RequestIcon} to="requests" text={translationRequestPage.t('requestPage.title')} />
          {/* <MyGroupsSidebarItem
            singularTitle="My Group"
            pluralTitle="My Groups"
            icon={GroupIcon}
          /> */}
          {/* <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" /> */}
          <SidebarItem icon={LibraryBooks} to="docs/default/component/backstage-docs" text={translationEntityPage.t('root.docs')} />
          <SidebarItem icon={CreateComponentIcon} to="create" text={translationEntityPage.t('root.create')} />
          {/* End global nav */}
          <SidebarScrollWrapper>
            {/* Items in this group will be scrollable if they run out of space */}
            {/* <SidebarItem
            icon={UpdateIcon}
            to="catalog-unprocessed-entities"
            text="Unprocessed Entities"
          /> */}
          </SidebarScrollWrapper>
        </SidebarGroup>
        <SidebarSpace />
        {/* <AgentForgeSidebarItem /> */}
        <ImpersonationControl />
        <AdminSidebarItem />
        <SidebarItem icon={Announcement} to="announcements" text={translationAnnouncements.t('table.title')} />
        <ExternalUsersSidebarItem />
        <NotificationsSidebarItem />
        {/* <Administration /> */}
        <SidebarGroup
          label="Settings"
          icon={<UserSettingsSignInAvatar />}
          to="/settings"
        >
          <SidebarSettings />
        </SidebarGroup>
      </Sidebar>
      {children}
    </SidebarPage>
  )
};
